import { Divider, IconChevronLeftRegular, NavigationBar, skinVars, Text2 } from '@telefonica/mistica';
import { t } from 'i18next';
import './index.scss';
import BreadCrumbsWrapper from '../BreadcrumbsWrapper';

interface BreadcrumbsItem {
    title: string;
    url: string;
}

interface HeaderComponentProps {
    breadcrumbs: BreadcrumbsItem[];
    title: string;
    navigationBarOnBack: () => void;
    data?: any[];
    withBorder?: boolean;
    isInverse?: boolean;
}

const HeaderComponent = ({
    breadcrumbs,
    title,
    navigationBarOnBack,
    data,
    withBorder = false,
    isInverse = false,
}: HeaderComponentProps) => {
    return (
        <div className='headerComponent'>
            <div className='headerComponent__container'>
                <div className='headerComponent__navigationBar'>
                    <NavigationBar
                        withBorder={withBorder}
                        variant={isInverse ? 'inverse' : 'default'}
                        onBack={navigationBarOnBack}
                        title={title}
                    />
                </div>
                <div className='headerComponent__return'>
                    <div className='headerComponent__return-icon' onClick={navigationBarOnBack}>
                        <IconChevronLeftRegular color={skinVars.colors.textPrimary} size={20} />
                    </div>
                    <div className='generic-header__return-back' onClick={navigationBarOnBack}>
                        <Text2 medium color={skinVars.colors.textPrimary}>
                            {t('returnResponsive')}
                        </Text2>
                    </div>
                </div>
                {(data === undefined || data.length !== 0) && (
                    <div className='headerComponent__breadcrumbs'>
                        <BreadCrumbsWrapper title={title} breadcrumbs={breadcrumbs} />
                    </div>
                )}
            </div>
            <div className='headerComponent__divider'>
                <Divider />
            </div>
        </div>
    );
};

export default HeaderComponent;
